<svg width="150" height="150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150.99 150.36">
	<defs>
		<style>
			.cls-1{ fill:{{color}}; }
		</style>
	</defs>
	<g id="Layer_2" data-name="Layer 2">
		<g id="Layer_1-2" data-name="Layer 1">
			<rect class="cls-1" x="7.38" y="107.32" width="35.65" height="35.65" transform="translate(95.88 18.83) rotate(45)"/>
			<rect class="cls-1" x="-12.7" y="57.71" width="177.5" height="34.46" transform="translate(75.27 -31.83) rotate(45)"/>
			<rect class="cls-1" x="48.04" y="32.33" width="105.52" height="34.46" transform="translate(207.11 13.33) rotate(135)"/>
		</g>
	</g>
</svg>